import { type PersonEducationResponse } from '@on3/api';
import { Link } from '@on3/ui-lib/components/Link';
import { Pen } from '@on3/ui-lib/components/Svg';
import { useAuth } from '@on3/ui-lib/index';
import { userHasPermission } from '@on3/ui-lib/utils/auth/access';
import { profileAdmin } from '@on3/ui-lib/utils/auth/constants';
import clsx from 'clsx';
import { MockDataBar } from 'components/Mock/MockDataBar';
import useAthlete from 'contexts/AthleteProvider';

import styles from './AcademicsModule.module.scss';

interface AcademicsModuleProps {
  academics?: PersonEducationResponse | null;
  className?: string;
}
export const AcademicsModule = ({
  academics,
  className,
}: AcademicsModuleProps) => {
  const { athlete } = useAthlete();
  const { user } = useAuth();
  const canEdit = userHasPermission(profileAdmin, user);

  return (
    <section className={clsx(styles.section, className)}>
      <h2>Academic Information</h2>
      <div className={styles.block}>
        <dl>
          <dt>GPA</dt>
          {academics?.gpa ? <dd>{academics?.gpa}</dd> : <MockDataBar />}
        </dl>
        <dl>
          <dt>ACT</dt>
          {academics?.act ? <dd>{academics?.act}</dd> : <MockDataBar />}
        </dl>
        <dl>
          <dt>SAT</dt>
          {academics?.sat ? <dd>{academics?.sat}</dd> : <MockDataBar />}
        </dl>
        <dl>
          <dt>Intended Major</dt>
          {academics?.intendedMajor ? (
            <dd>{academics?.intendedMajor}</dd>
          ) : (
            <MockDataBar />
          )}
        </dl>
      </div>
      <div>
        <Link
          className={styles.edit}
          forceReload
          href={
            canEdit
              ? `/rivals/${athlete.slug}/elite/network/profile/academics/`
              : `/rivals/${athlete.slug}/claim-profile/`
          }
        >
          <Pen />
          Edit Academics
        </Link>
      </div>
    </section>
  );
};
